import { Attr, HasOne, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Category from "./Category";
import type SourceGroup from "./SourceGroup";

@Model()
class Podcast extends ApplicationRecord {
  static jsonapiType = "podcasts";

  @Attr() aliases: string[];

  @Attr({ persist: false }) archivedAt: string;

  @HasOne() category: Category;

  @Attr() categoryId: number;

  @Attr({ persist: false }) createdAt: string;

  @Attr() feedUrl: string;

  @Attr() genres: string[];

  @Attr() itunesCollectionId: string;

  @Attr() label: string;

  @HasOne() location: Location;

  @Attr() locationId: number;

  @Attr() logoData: string;

  @Attr() logoUrl: string;

  @Attr({ persist: false }) medium: string;

  @Attr() name: string;

  @Attr() notes: string;

  @Attr() primaryGenre: string;

  @HasOne() sourceGroup: SourceGroup;

  @Attr() tier: number;

  @Attr() timeZone: string;

  @Attr({ persist: false }) updatedAt: string;

  @Attr() url: string;

  @Attr() visible: boolean;
}

export default Podcast;
